export enum EnvConfigKeys {
    chatLLMBaseUrl = 'chatLLMBaseUrl',
    resellerTokenLoginBaseUrl = 'resellerTokenLoginBaseUrl',
    resellerTokenLoginBaseUrlB2C = 'resellerTokenLoginBaseUrlB2C',
    resellerTokenLoginBaseUrlB2U = 'resellerTokenLoginBaseUrlB2U',
    auth0ClientId = 'AUTH0_CLIENT_ID',
    auth0RedirectUri = 'AUTH0_REDIRECT_URI',
    msalAuthority = 'MSAL_AUTHORITY'
}